export default __webpack_public_path__ + "static/media/contact_banner.5c95a73d.jpg";